import type { Coach, User } from '@/types';

// TODO: Remove this, it makes no sense to make this differentiation
export const currentUserQueryKeyName = (isClient: boolean) =>
  `current-user-${isClient ? 'client' : 'coach'}`;

// Utility function to look up which coach user a card/action is referring to.
export const oldCoachToNew = (coach: Coach, coaches: User[] = []) =>
  coaches.find((user) => user.id === (coach as unknown as User).id);
